import type { PricingPackageSection } from "@/types/content";

interface Props {
  section: PricingPackageSection;
}

export default function PricingPackageSectionBlock({ section }: Props) {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <div className="max-w-5xl mx-auto">
        {section.title && (
          <h2 className="text-2xl md:text-3xl font-bold text-slate-800 text-center mb-10">
            {section.title}
          </h2>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {section.packages.map((pkg) => (
            <div
              key={pkg._key}
              className={`rounded-xl p-6 border ${
                pkg.highlighted
                  ? "border-primary bg-primary/5"
                  : "border-slate-100 bg-white"
              }`}
            >
              <h3 className="text-lg font-semibold text-slate-800 mb-2">
                {pkg.name}
              </h3>
              <div className="mb-4">
                <span className="text-2xl font-bold text-slate-900">
                  {pkg.price}
                </span>
                {pkg.period && (
                  <span className="text-sm text-slate-400 ml-1">
                    / {pkg.period}
                  </span>
                )}
              </div>
              <ul className="space-y-2 mb-6">
                {pkg.features.map((feature, idx) => (
                  <li
                    key={idx}
                    className="flex items-center gap-2 text-sm text-slate-600"
                  >
                    <i className="ri-check-line text-primary" />
                    {feature}
                  </li>
                ))}
              </ul>
              <a
                href={pkg.ctaHref}
                className={`block text-center w-full py-2.5 rounded-full font-medium text-sm transition-colors whitespace-nowrap ${
                  pkg.highlighted
                    ? "bg-primary text-white hover:bg-primary-dark"
                    : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                }`}
              >
                {pkg.ctaLabel}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}